import React from 'react';
import SectionHeadingStyle2 from '../../SectionHeading/SectionHeadingStyle2';
import config from '../../../config';
import Crest from '../../Crest';

export default function CrestSection({ data, sectionTitle, sectionTitleUp }) {
  return (
    <div className="container">
      {sectionTitle && (
        <SectionHeadingStyle2
          sectionTitle={sectionTitle}
          sectionTitleUp={sectionTitleUp}
        />
      )}

      <div className="row">
        {data?.map((item, index) => (
          <div className="col-lg-12" key={index}>
            <Crest
              key={index}
              imgLink={config.baseUrl+ item.imgLink}
              name={item.name}
              description={item.description}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
